module.exports = __webpack_public_path__ + "img/quick_style.1f138460.svg";